export enum ChallengeDifficulty {
    EASY,
    NORMAL,
    HARD,
    ALL
}
